import React, { Component } from 'react';
import { Icon, Toast } from '@paypalcorp/pp-react';
import styles from './SetPreferredHeart.less';

export default class SetPreferredHeart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToastPreferredMessage: this.props.showToastPreferredMessage,
      isPreferredCharitySwitch: this.props.isPreferredCharitySwitch,
    };
  }

  getToastPreferredMessage() {
    if (this.props.hasError) {
      return this.props.errorMessage;
    }

    if (!this.props.selected) {
      return this.props
        .i18n('toast.no-longer-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }

    if (this.props.selected && this.state.isPreferredCharitySwitch) {
      return this.props
        .i18n('toast.new-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }
    return this.props.i18n('toast.preferred-charity');
  }

  componentWillUnmount() {
    this.setState({
      showToastPreferredMessage: false,
      isPreferredCharitySwitch: false,
    });
  }

  renderHeartIcon() {
    return this.props.selected ? (
      <Icon
        alt='set-favorite-heart'
        className={styles['heart-filled']}
        name='favorite-selected'
        size={this.props.hubFlow ? 'md' : 'sm'}
        data-nemo='npo-heart-filled'
      />
    ) : (
      <Icon
        alt='set-favorite-heart'
        className={styles['heart-empty']}
        name='favorite'
        size={this.props.hubFlow ? 'md' : 'sm'}
      />
    );
  }

  render() {
    return (
      <>
        {this.state.showToastPreferredMessage && (
          <Toast
            key='toast_success'
            id='toast_success'
            message={this.getToastPreferredMessage()}
            isSuccess={this.props.selected && !this.props.hasError}
            theme='v2'
          />
        )}
        {this.renderHeartIcon()}
      </>
    );
  }
}
